import React from 'react';

import {
  Accordion,
  Avatar,
  Box,
  Text,
  useTheme,
} from '@ublend-npm/aulaui-core';

import { EDUCATOR_ROLE } from '@core/constants/space';

import ParticipantHistoryAccordionItem from './ParticipantHistoryAccordionItem';
import { ParticipantHistoryEvent } from './types';
import { DARK } from '@core/constants/theme';

type ParticipantHistoryAccordionProps = {
  event: ParticipantHistoryEvent;
};

const ParticipantHistoryAccordion = ({
  event,
}: ParticipantHistoryAccordionProps) => {
  const { palette } = useTheme();
  const isDarkTheme = palette?.mode === DARK;

  let label = event.data.length.toString();
  if (event.eventType === 'added') {
    label = `+${label}`;
  } else if (event.eventType === 'removed') {
    label = `-${label}`;
  }

  const textSx =
    event.eventType === 'removed'
      ? {
          color: isDarkTheme ? palette.error.light : palette.error.dark,
        }
      : {};

  return (
    <Accordion
      key={event.eventType}
      arrowPosition="right"
      headerElement={
        <Box sx={{ py: 1, display: 'flex', gap: 1.5, alignItems: 'center' }}>
          <Avatar
            fallbackText={label}
            sx={{ fontSize: '1rem', width: 32, height: 32 }}
          />
          <Text sx={textSx}>
            {event.data.length} users were {event.eventType} by {event.user}
          </Text>
        </Box>
      }
      label={`${event.data.length} users were ${event.eventType} by ${event.user}`}
      sx={{
        mt: 1,
        background: 'transparent',
        '& .MuiAccordionSummary-root': {
          '&:hover': {
            backgroundColor: palette.action.hover,
          },
        },
        '& .MuiAccordionSummary-content': { ml: '0 !important' },
        '& .MuiAccordionDetails-root': {
          p: 0,
          '& > .MuiBox-root': { p: 0, maxHeight: 'none' },
        },
      }}
    >
      {event.data.map((ev) => (
        <ParticipantHistoryAccordionItem
          avatar={ev.participant.avatar}
          isEducator={ev.role === EDUCATOR_ROLE}
          firstName={ev.participant.firstName}
          lastName={ev.participant.lastName}
        />
      ))}
    </Accordion>
  );
};

export default ParticipantHistoryAccordion;
